import React from 'react';

const About = () => {
    return (
        <div>
            <h1>About page</h1>
            
        </div>
    );
};

export default About;